import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class UniqueIdService {

  private carachters = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
  ]

  private idList: string[] = [];

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {}

  public generateWithPrefix(prefix: string): string {
    const id = `${prefix}-${this.generate(8)}`;
    if (this.verify(id)) {
      this.idList.push(id);
      return id;
    } else {
      return this.generateWithPrefix(prefix);
    }
  }

  private generate(size: number): string {
    let state = '';
    for (let i = 0; i < size; i++) {
      const index = Math.floor((this.carachters.length - 1) * Math.random())
      state += this.carachters[index]
    }
    return state;
  }

  private verify(id: string): boolean {
    return !this.idList.includes(id) && this.document.getElementById(id) === null;
  }

}
